import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { showToast } from '@features';
import { uploadFile } from '@widgets/Files/api/uploadFile';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

import { filesActions } from '../../../store/slices/filesSlice/filesSlice';

interface IUseUploadFiles {
    onErrorCb: () => void;
    fileNames: string[];
    currentFolderName: string;
}

export const useUploadFiles = ({ onErrorCb, fileNames, currentFolderName }: IUseUploadFiles) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['uploadFiles'],
        mutationFn: uploadFile,
        onSuccess: (data) => {
            handleStatusError(data, t('useFileUpload.return.swal.manyFiles.button'));
            if (data?.data?.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
                showToast(
                    `${
                        fileNames.length > 1
                            ? t('Files.FileNotificationsPush.fileText.plural')
                            : t('Files.FileNotificationsPush.fileText.one')
                    } ${fileNames.join(', ')} ${
                        fileNames.length > 1
                            ? t('Files.FileNotificationsPush.fileText.were')
                            : t('Files.FileNotificationsPush.fileText.was')
                    } ${t('Files.FileNotificationsPush.fileText.success')} ${
                        fileNames.length > 1
                            ? t('Files.FileNotificationsPush.fileText.download.plural')
                            : t('Files.FileNotificationsPush.fileText.download.one')
                    } ${t('Files.FileNotificationsPush.fileText.inFolder')} ${currentFolderName}`
                );
            } else {
                onErrorCb();
            }
            dispatch(filesActions.changeUploadFiles([]));
        },
        onError: (err) => {
            dispatch(filesActions.changeUploadFiles([]));
            console.error('err in useUploadFiles: ', err);
        },
    });
};
